module.exports = __webpack_public_path__ + "img/contact.a4fd0ed.webp";